import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useUpdateLegalMatterMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: Api.ILegalMatter) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({
			matter,
			impersonationContext,
		}: {
			matter: Api.ILegalMatter;
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			return userSession.webServiceHelper.callAsync<Api.ILegalMatter>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `LegalMatter/${matter.id}`,
				}),
				'PUT',
				matter
			);
		},
		onError,
		onSuccess,
	});
};
